import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { SharedAngular } from '../../@types/sharedAngular';
import angular from 'angular';
import { IStateService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.setup').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.setuptaggroups, {
    url: '/tags',
    params: { flowId: null, title: 'Setup - Tags' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'permissionsService',
          '$state',
          'pubsubService',
          'brandingService',
          function (
            permissionsService: SharedAngular.PermissionsService,
            $state: IStateService,
            pubsubService: SharedAngular.PubSubService,
            brandingService: SharedAngular.BrandingService
          ) {
            if (
              !permissionsService.currentUserHasAnyOfPermissions([
                FlowinglyPermissions.SETUP_TAG_ACCESS,
                FlowinglyPermissions.SETUP_TAG_UPDATE
              ])
            ) {
              $state.go(STATE_MAPPINGS.flowsactive);
            }

            this.helpUri = brandingService.getBrandedHelpUri(
              'https://help.flowingly.net/en/articles/11958073-tagging'
            );

            this.onAddButtonClick = function () {
              pubsubService.publish('SETUP_TAGGROUP_ADD_CLICKED');
            };
          }
        ],
        templateUrl:
          'Client/runner.setup/runner.setup.taggroups/runner.setup.taggroups.tmpl.html'
      }
    }
  });
}
